import { Pipe, PipeTransform } from '@angular/core';

/**
 * key - size of the container
 * value - sort priority weight with the step of 10 to be able to add more later in between
 */
const CONTAINER_WEIGHT_MAPPING: { [key: number]: number } = {
  96: 10, // gallons
  2: 20, // cubic yard
  4: 30, // cubic yard
  6: 40, // cubic yard
  8: 50, // cubic yard
  10: 60, // cubic yard
};

@Pipe({
  name: 'sortCommercialContainers',
  standalone: true,
})
export class SortCommercialContainersPipe implements PipeTransform {
  public transform(values: number[]): number[] {
    return [...values].sort((a, b) => CONTAINER_WEIGHT_MAPPING[a] - CONTAINER_WEIGHT_MAPPING[b]);
  }
}
